<template>
  <div class="flex-row align-items-center avatars">
    <div
        v-for="(avatarAndName, key) in avatars"
        :key="key"
        class="custom-avatar-wrapper">
      <a-tooltip
          :title="avatarAndName.name"
      >
        <a-avatar size="small" :src="avatarAndName.src"></a-avatar>
      </a-tooltip>
    </div>
    <div
      v-if="overflow > 0"
        class="custom-avatar-wrapper overflow">
      <a-tooltip
          :title="overflowTitle"
      >
        <a-avatar  size="small">
          +{{ overflow }}
        </a-avatar>
      </a-tooltip>
    </div>


  </div>
</template>

<script>
export default {
  name: "MultipleAvatarsCell",
  props: {
    cellProps: {
      type: Array,
    },
    limit: {
      type: Number,
      default: 4,
    }
  },
  data() {
    return {
      overflow:0,
    }
  },
  computed: {
    avatars() {
      if (this.cellProps.length > this.limit) {
        this.overflow = this.cellProps.length - this.limit;
      }
      return this.cellProps.slice(0, this.limit);
    },
    overflowAvatars() {
      return this.cellProps.slice(this.limit, this.cellProps.length);
    },
    overflowTitle() {
      let title = '';
       this.overflowAvatars.forEach((avatarAndName, idx) => {
         if (idx === 0) {
           title = avatarAndName.name;
           return;
         }
        title += ' en ' + avatarAndName.name;
      })
      return title;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.avatars {
  margin-left: 10px;
  .custom-avatar-wrapper {
    margin-left: -10px;
  }
  .ant-avatar {
    border: 1px solid white;
  }
  .overflow {
    .ant-avatar {
      background-color: $brand-primary;
      color: white;
      font-weight: 500;
      font-size: $font-size-small;
    }
  }
}

</style>
